import { render, staticRenderFns } from "./InstallmentPaymentCards.vue?vue&type=template&id=2d50709a&"
import script from "./InstallmentPaymentCards.vue?vue&type=script&lang=js&"
export * from "./InstallmentPaymentCards.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports